import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from './cn';

type Variant = 'primary' | 'secondary' | 'ghost' | 'destructive' | 'quiet-destructive';

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-accent text-on-accent enabled:hover:brightness-110',
  secondary: 'bg-secondary text-fg enabled:hover:bg-[var(--hover-strong)]',
  ghost: 'bg-transparent text-fg enabled:hover:bg-secondary',
  destructive: 'bg-destructive text-on-destructive enabled:hover:brightness-110',
  /** A delete that has Undo: red text, no fill. */
  'quiet-destructive': 'bg-transparent text-destructive enabled:hover:bg-secondary',
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  block?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', block, className, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex min-h-11 min-w-11 items-center justify-center gap-2 rounded-full px-5 text-base font-medium',
        'motion-safe:transition-transform motion-safe:duration-100 motion-safe:active:scale-[0.98]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        VARIANTS[variant],
        block && 'w-full',
        className,
      )}
      {...rest}
    />
  );
});
